import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { FetchQueryOptions } from '@tanstack/react-query';
import { getEntityValues } from '@terminal/services/get-entity-values/getEntityValues';
import { queryClient } from '@terminal/services/query-client/queryClient';
import { mapEntityValues } from '@terminal/stores/use-watchlist/mapEntityValues';
import { WatchlistEntities } from '@terminal/stores/use-watchlist/watchlist-types';
export const WATCHLIST_ENTITY_QUERY_KEY = 'watchlist_entity';

export const fetchWatchlistEntityQuery = (tag: string) =>
  queryClient.fetchQuery(createQueryOptions(tag));

export const createQueryOptions = (
  tag: string
): FetchQueryOptions<WatchlistEntities | null> => ({
  queryKey: [WATCHLIST_ENTITY_QUERY_KEY, tag],
  queryFn: async () => {
    const res = await getEntityValues(tag);

    if (!res) {
      return null;
    }

    if (!res.snakeMeta) {
      return null;
    }

    const mapped = mapEntityValues({
      entities: [{ tag }],
      ...res,
      tag,
    });

    return mapped[0];
  },
  staleTime: getTimeTillEndOfDayMs(),
});
